import { SelfProfileEdit } from '@/modules/hr-directory';

/** `/my-profile/edit`: the signed-in person edits their own personal details, contact details and skills. */
export const ProfileEditPage = () => <SelfProfileEdit />;
